import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderContentsStore implements SaveStateHolder {
  @observable
  readonly contentIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly blockId: number,
              contentIds: number[]) {
    makeObservable(this);
    this.contentIds = contentIds;
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.contentIds, index1, index2);
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const reordered = this.contentIds.slice();
    this.save = contentLoaders.x8block.orderChildren(this.blockId, reordered);
  }
}
